import { makeStyles } from "@material-ui/core/styles";
import { COLORS } from "../../../constants/colors";

export default makeStyles((theme) => ({
  card: {
    position: "relative",
  },
  promoCodeExpiredOverlay: {
    visibility: "invisible",
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    opacity: 0.9,
    backgroundColor: "black",
    zIndex: 9999,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  promoCodeExpiredText: {
    fontFamily: "Montserrat",
    fontSize: 35,
    color: "white",
    textAlign: "center",
  },
  productCategoryContainer: {
    width: "100%",
  },
  productCategory: {
    width: "max-content",
    backgroundColor: `${COLORS.amazonColor}`,
    margin: "8px",
    padding: "2px 15px",
  },
  productCategoryText: {
    color: "black",
    fontSize: 14,
    fontWeight: 700,
    fontFamilty: "Montserrat",
  },
  productName: {
    fontFamily: "Montserrat",
    height: 175,
    fontWeight: "bold",
  },
  productInfo: {
    height: 450,
    padding: 10,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    "&:last-child": {
      paddingBottom: "15px",
    },
  },
  productPrice: {
    backgroundColor: `${COLORS.accent}`,
    fontFamily: "Blinker",
    padding: "20px",
    marginBottom: "15px",
  },
  cardMedia: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: 200,
  },
  image: {
    height: "150px",
  },
  productInfoContainer: {
    display: "flex",
    alignItems: "center",
    padding: "5px 0px",
  },
  productOldPrice: {
    padding: "0 10px",
    fontSize: 12,
    textDecoration: "line-through",
  },
  productNewPrice: {
    padding: "0 10px",
    fontSize: "16px",
    fontWeight: "bold",
  },
  productDiscountPercentage: {
    padding: "0 10px",
    fontSize: "14px",
    fontWeight: "bold",
  },
  productExtraInfo: {
    padding: "0 10px",
    fontSize: "14px",
  },
  productButton: {
    width: "100%",
    backgroundColor: `${COLORS.amazonColor}`,
    color: "black",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "&:hover": {
      backgroundColor: `${COLORS.amazonDarkColor}`,
    },
  },
  link: {
    textDecoration: "none",
    "&:hover": {
      textDecoration: "none",
    },
  },
}));
